<template>
  <div class="home">
    <div class="hero">
      <div class="hero-content">
        <span class="welcome">Welcome to Zimbabwe</span>
        <h1 class="brand">
          <span class="highlight">AFRI BAGS</span>
        </h1>
        <p>Your Trusted Partner in Industrial Packaging Solutions</p>
        <router-link to="/contact" class="cta-button">Get a Quote</router-link>
      </div>
      <div class="hero-overlay"></div>
    </div>

    <section class="features" data-aos="fade-up">
      <div class="feature-container">
        <div class="feature" data-aos="zoom-in" data-aos-delay="100">
          <div class="feature-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h3>Quality Assured</h3>
          <p>ISO certified manufacturer of premium PP bags</p>
        </div>
        <div class="feature" data-aos="zoom-in" data-aos-delay="200">
          <div class="feature-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
              ></path>
            </svg>
          </div>
          <h3>Capacity Range</h3>
          <p>Flexible packaging solutions from 5-120 KG</p>
        </div>
        <div class="feature" data-aos="zoom-in" data-aos-delay="300">
          <div class="feature-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <h3>Durability</h3>
          <p>Superior strength and puncture-resistant material</p>
        </div>
      </div>
    </section>

    <section class="about-section" data-aos="fade-up">
      <div class="about-content">
        <h2>Premium PP Woven Sacks</h2>
        <div class="about-grid">
          <div class="about-text" data-aos="fade-right">
            <p>
              Throughout the years, PP Woven Sacks have demonstrated their
              greatness in the packaging unit of several enterprises. Such sacks
              are known to be the toughest packaging bags, high in demand in the
              industries of sugar, grains, milling, and food.
            </p>
            <p>
              We feel pleasure to introduce ourselves as an ISO certified PP bag
              manufacturer, supplier, and exporter, which are used as packaging
              materials in different industries. Our PP Woven Sacks are
              flexible, high in strength and durable in the packaging industry.
            </p>
          </div>
          <div class="about-stats" data-aos="fade-left">
            <div class="stat-item">
              <span class="stat-number">5-120</span>
              <span class="stat-label">KG Capacity</span>
            </div>
            <div class="stat-item">
              <span class="stat-number">ISO</span>
              <span class="stat-label">Certified</span>
            </div>
            <div class="stat-item">
              <span class="stat-number">100%</span>
              <span class="stat-label">Quality Assured</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="ceo-section" data-aos="fade-up">
      <div class="ceo-content">
        <div class="ceo-image">
          <img src="@/assets/aron.png" alt="Aron Shibu - CEO of Afri Bags" />
        </div>
        <div class="ceo-message">
          <h2>Word from the CEO</h2>
          <p>
            "At Afri Bags, our unwavering commitment is to deliver excellence in
            every product we manufacture. We understand that quality packaging
            is crucial for our clients' success, which is why we've invested in
            state-of-the-art technology and rigorous quality control processes.
            Our vision is to be Zimbabwe's most trusted name in industrial
            packaging, one bag at a time."
          </p>
          <div class="ceo-signature">
            <span class="name">Aron Shibu</span>
            <span class="title">Chief Executive Officer</span>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-section" data-aos="fade-up">
      <div class="cta-content">
        <h2>Ready to Order?</h2>
        <p>Contact us today for premium quality PP Woven Sacks</p>
        <router-link to="/contact" class="cta-button pulse">
          Contact Us
        </router-link>
      </div>
      <div class="cta-background"></div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "HomeView",
  mounted() {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 50,
    });
  },
};
</script>

<style lang="scss" scoped>
.home {
  .hero {
    position: relative;
    background: linear-gradient(135deg, #1a4d2e 0%, #2d8a4c 100%);
    min-height: 100vh;
    padding-top: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: white;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 17v-7h2v7h7v2h-7v7h-2v-7h-7v-2h7z' fill='%23ffffff' fill-opacity='0.15'/%3E%3C/svg%3E");
      opacity: 0.15;
      z-index: 1;
    }

    .hero-content {
      position: relative;
      z-index: 2;
      padding: 0 1rem;
      width: 100%;
      max-width: 800px;

      @media (max-width: 768px) {
        padding: 0 1.5rem;

        .welcome {
          font-size: 1rem;
        }

        h1 {
          font-size: 2.5rem;
        }

        p {
          font-size: 1.2rem;
        }
      }

      .welcome {
        display: block;
        font-size: 1.2rem;
        text-transform: uppercase;
        letter-spacing: 3px;
        margin-bottom: 0.5rem;
        opacity: 0;
        animation: fadeInWelcome 0.5s ease-out forwards;
      }

      h1 {
        font-size: 5rem;
        margin-bottom: 1.5rem;
        font-weight: 800;
        letter-spacing: -1px;
        line-height: 1;
        opacity: 0;
        animation: fadeInTitle 0.8s ease-out 0.3s forwards;

        .highlight {
          color: #ffd700;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 100%;
            height: 3px;
            background: #ffd700;
            transform: scaleX(0);
            transform-origin: right;
            transition: transform 0.3s ease;
          }
        }

        &:hover .highlight::after {
          transform: scaleX(1);
          transform-origin: left;
        }
      }

      p {
        font-size: 1.5rem;
        margin-bottom: 2rem;
        opacity: 0;
        animation: fadeInContent 0.8s ease-out 0.6s forwards;
      }

      .cta-button {
        opacity: 0;
        animation: fadeInButton 0.8s ease-out 0.9s forwards;
      }
    }
  }

  .features {
    padding: 6rem 2rem;
    background-color: #f8f9fa;

    .feature-container {
      max-width: 1200px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
    }

    .feature {
      text-align: center;
      padding: 3rem 2rem;
      background: white;
      border-radius: 12px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
      transition: transform 0.3s ease, box-shadow 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1);
      }

      .feature-icon {
        width: 64px;
        height: 64px;
        margin: 0 auto 1.5rem;
        color: #1a4d2e;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      h3 {
        color: #1a4d2e;
        margin-bottom: 1rem;
        font-size: 1.5rem;
      }

      p {
        color: #666;
        line-height: 1.6;
      }
    }
  }

  .about-section {
    padding: 6rem 2rem;
    background-color: white;

    .about-content {
      max-width: 1200px;
      margin: 0 auto;

      h2 {
        color: #1a4d2e;
        margin-bottom: 3rem;
        text-align: center;
        font-size: 2.5rem;
        font-weight: 700;
      }

      .about-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 4rem;
        align-items: center;

        @media (max-width: 768px) {
          grid-template-columns: 1fr;
          gap: 2rem;
        }

        .about-text {
          p {
            margin-bottom: 1.5rem;
            line-height: 1.8;
            color: #444;
            font-size: 1.1rem;

            @media (max-width: 768px) {
              font-size: 1rem;
              margin-bottom: 1rem;
            }
          }
        }

        .about-stats {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 2rem;

          @media (max-width: 768px) {
            grid-template-columns: 1fr;
            gap: 1rem;
          }

          .stat-item {
            text-align: center;
            padding: 2rem;
            background: #f8f9fa;
            border-radius: 12px;
            transition: transform 0.3s ease;

            @media (max-width: 768px) {
              padding: 1.5rem;
            }

            &:hover {
              transform: translateY(-5px);
            }

            .stat-number {
              display: block;
              font-size: 2.5rem;
              font-weight: 700;
              color: #1a4d2e;
              margin-bottom: 0.5rem;

              @media (max-width: 768px) {
                font-size: 2rem;
              }
            }

            .stat-label {
              color: #666;
              font-size: 1.1rem;

              @media (max-width: 768px) {
                font-size: 1rem;
              }
            }
          }

          .stat-item:nth-child(3) {
            grid-column: auto;

            @media (min-width: 769px) {
              grid-column: span 2;
            }
          }
        }
      }
    }
  }

  .ceo-section {
    padding: 6rem 2rem;
    background: #f9f9f9;

    @media (max-width: 768px) {
      padding: 4rem 1.5rem;
    }

    .ceo-content {
      max-width: 1200px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: 300px 1fr;
      gap: 4rem;
      align-items: center;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 2rem;
        text-align: center;
      }

      .ceo-image {
        img {
          width: 100%;
          height: 300px;
          object-fit: cover;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }

      .ceo-message {
        h2 {
          color: #1a4d2e;
          font-size: 2rem;
          margin-bottom: 1.5rem;
          font-weight: 700;

          @media (max-width: 768px) {
            font-size: 1.75rem;
          }
        }

        p {
          color: #444;
          font-size: 1.1rem;
          line-height: 1.8;
          margin-bottom: 2rem;
          font-style: italic;

          @media (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .ceo-signature {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;

          @media (max-width: 768px) {
            align-items: center;
          }

          .name {
            color: #1a4d2e;
            font-size: 1.25rem;
            font-weight: 600;
          }

          .title {
            color: #666;
            font-size: 1rem;
          }
        }
      }
    }
  }

  .cta-section {
    position: relative;
    background-color: #1a4d2e;
    color: white;
    padding: 6rem 2rem;
    text-align: center;
    overflow: hidden;

    .cta-content {
      position: relative;
      z-index: 2;
      max-width: 600px;
      margin: 0 auto;

      h2 {
        font-size: 2.5rem;
        margin-bottom: 1rem;
        font-weight: 700;
      }

      p {
        margin-bottom: 2rem;
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }

    .cta-background {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      opacity: 0.1;
    }
  }
}

.cta-button {
  display: inline-block;
  background-color: #ffd700;
  color: #1a4d2e;
  padding: 1rem 2.5rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  &:hover {
    background-color: transparent;
    border-color: #ffd700;
    color: #ffd700;
    transform: translateY(-2px);
  }

  &.pulse {
    animation: pulse 2s infinite;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 215, 0, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 215, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 215, 0, 0);
  }
}

@keyframes fadeInWelcome {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 0.9;
    transform: translateY(0);
  }
}

@keyframes fadeInTitle {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInContent {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 0.9;
    transform: translateY(0);
  }
}

@keyframes fadeInButton {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .home {
    .hero {
      height: 70vh;

      .hero-content {
        .welcome {
          font-size: 1rem;
        }

        h1 {
          font-size: 3.5rem;
        }

        p {
          font-size: 1.2rem;
        }
      }
    }

    .features {
      .feature-container {
        grid-template-columns: 1fr;
      }
    }

    .about-section {
      .about-content {
        .about-grid {
          grid-template-columns: 1fr;
          gap: 2rem;
        }
      }
    }
  }
}
</style>
